import React, { useEffect, useState } from 'react';
import './Common.css';

type ToastType = 'success' | 'error' | 'warning';

interface ToastMessage {
  id: number;
  text: string;
  type: ToastType;
}

let toastId = 0;
const listeners: Array<(msg: ToastMessage) => void> = [];

export const toast = {
  success: (text: string) => listeners.forEach(fn => fn({ id: ++toastId, text, type: 'success' })),
  error: (text: string) => listeners.forEach(fn => fn({ id: ++toastId, text, type: 'error' })),
  warning: (text: string) => listeners.forEach(fn => fn({ id: ++toastId, text, type: 'warning' })),
};

const ToastContainer: React.FC = () => {
  const [messages, setMessages] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const handler = (msg: ToastMessage) => {
      setMessages(prev => [...prev, msg]);
      setTimeout(() => setMessages(prev => prev.filter(m => m.id !== msg.id)), 4000);
    };
    listeners.push(handler);
    return () => { listeners.splice(listeners.indexOf(handler), 1); };
  }, []);

  return (
    <div className="toast-container">
      {messages.map(m => (
        <div key={m.id} className={`toast toast--${m.type}`}>
          {m.text}
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
